import { render, staticRenderFns } from "./DefaulterParentsList.vue?vue&type=template&id=5ca859b6&scoped=true"
import script from "./DefaulterParentsList.vue?vue&type=script&lang=js"
export * from "./DefaulterParentsList.vue?vue&type=script&lang=js"
import style0 from "./DefaulterParentsList.vue?vue&type=style&index=0&id=5ca859b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca859b6",
  null
  
)

export default component.exports